import React from 'react';
import ChatLayout from '../components/chat/ChatLayout';

const Chat = () => {
    return <ChatLayout />;
};

export default Chat;
